import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={393}
    height={242}
    fill="none"
    {...props}
  >
    <path
      stroke="#00E9BA"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M210.5 186H406M178 186H-17.5"
    />
    <path
      fill="#425596"
      stroke="#425596"
      d="m191.365 188.906-.08-.197-.197-.08-7.752-3.129 7.752-3.129.197-.08.08-.197 3.131-7.759 3.139 7.76.08.197.197.079 7.752 3.129-7.752 3.129-.197.079-.08.197-3.139 7.76-3.131-7.759Z"
    />
    <path
      fill="#24EAA8"
      d="M335 226.952c0 8.008 6.492 14.5 14.5 14.5s14.5-6.492 14.5-14.5-6.492-14.5-14.5-14.5-14.5 6.492-14.5 14.5Z"
    />
    <path
      stroke="#425596"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M349 1v226.5"
    />
    <path fill="#fff" d="M349.5 232a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Z" />
  </svg>
)
export default SvgComponent
